import { ReactElement } from 'react';
import {
	DocIcon,
	ExcelIcon,
	ImageAttachmentIcon,
	OtherFileIcon,
	PDFAttachmentIcon,
} from 'src/icons/fileUpload/attachmentIcons';

const formatFileSize = (sizeInBytes: number): string => {
	if (sizeInBytes < 1024) {
		return `${sizeInBytes} bytes`;
	} else if (sizeInBytes < 1024 * 1024) {
		const sizeInKB = (sizeInBytes / 1024).toFixed();
		return `${sizeInKB}KB`;
	} else {
		const sizeInMB = (sizeInBytes / (1024 * 1024)).toFixed();
		return `${sizeInMB}MB`;
	}
};
const getFileTypeByExtension = (fileExtension: string | undefined) => {
	switch (fileExtension) {
		case '.pdf':
			return 'pdf';
		case '.png':
		case '.jpg':
		case '.jpeg':
		case '.gif':
			return 'image';
		case '.doc':
		case '.docx':
			return 'word';
		case '.csv':
		case '.xls':
		case '.xlsx':
			return 'excel';
		default:
			return 'default';
	}
};
const attachmentTypeToIcon: { [key: string]: ReactElement } = {
	image: <ImageAttachmentIcon />,
	pdf: <PDFAttachmentIcon />,
	word: <DocIcon />,
	excel: <ExcelIcon />,
	default: <OtherFileIcon />,
};

export { formatFileSize, getFileTypeByExtension, attachmentTypeToIcon };
